"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Mode = Object.freeze({
  NAVIGATION: 'navigation',
  ACTIONABLE: 'actionable'
});
var _default = Mode;
exports.default = _default;


// WEBPACK FOOTER //
// ./~/@salesforce/design-system-react/lib/components/data-table/private/mode.js